import React from 'react'
import moment from 'moment-jalaali'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InputField, Select } from 'src/components/UI'
import { CrewMutateFormType } from '../Information'
import { Close, EditIcon } from 'src/icons/icons'
import { AvatarSection } from './AvatarSection'
import { useQuery } from 'react-query'
import { Country, ListResponseType } from 'src/types'
import { Get } from 'src/apis/apiWithType'
import { useSelector } from 'react-redux'

export const BasicInfo = ({ mode }: { mode?: string | null }) => {

    const { t } = useTranslation()

    const { register, formState: { errors }, watch } = useFormContext<CrewMutateFormType>()


    const errorGenertor = (key: keyof CrewMutateFormType) => ({ error: !!errors?.[key], errorText: errors?.[key]?.message })

    const errorText = (title: string) => `${title} ${t('IsRequired')}`

    const { data, isLoading } = useQuery<ListResponseType<Country>>({
        queryFn: () => Get('https://api.flysepehr.com/api/v1/basic-information/country?page=1&per_page=50'),
        queryKey: ['GetCountries']
    })

    const lng = useSelector((state) => (state as any).common.lng)


    return (
        <div className='flex flex-col  gap-4 bg-white p-4 rounded-lg border '>
            <span className='font-semibold'>{t('BasicInfo')}</span>

            <div className='flex flex-col lg:flex-row gap-6  items-stretch lg:items-center'>

                {mode == 'edit' && <AvatarSection />}


                <div className='grid grid-cols-1 lg:grid-cols-6 gap-6 p-0 items-end flex-1'>

                    <div className='col-span-6 lg:col-span-2'>
                        <InputField
                            label={t('name')}
                            {...register('name', { required: { value: true, message: errorText(t('name')) } })}
                            {...errorGenertor('name')}
                        />
                    </div>


                    <div className='col-span-6 lg:col-span-2'>
                        <InputField
                            label={t('family')}
                            {...register('last_name', { required: { value: true, message: errorText(t('family')) } })}
                            {...errorGenertor('last_name')}
                        />
                    </div>


                    <div className='col-span-6 lg:col-span-2 '>
                        <InputField
                            label={t('father')}
                            {...register('father_name', { required: { value: true, message: errorText(t('father')) } })}
                            {...errorGenertor('father_name')}

                        />
                    </div>
                    <div className='col-span-6 lg:col-span-1 flex flex-row gap-4 items-center '>

                        <Select
                            label={t('gender')}
                            options={[{ label: t('man'), value: '1' }, { label: t('woman'), value: '2' }]}
                            unselectedLabel={`--${t('gender')}--`}
                            {...errorGenertor('gender')}
                            {...register('gender', { required: { value: true, message: errorText(t('gender')) } })}
                        />

                        {/* <span className='text-gray-500'>{t('gender')}</span>

                    <label className='flex flex-row gap-2 items-center cursor-pointer'>
                        <span>{t('man')}</span>
                        <input  type='radio' value={'Men'} {...register('gender')}/>
                    </label>

                    <label className='flex flex-row gap-2 items-center cursor-pointer'>
                        <span>{t('woman')}</span>
                        <input type='radio' value={'Men'} {...register('gender')} />
                    </label> */}
                    </div>

                    <div className='col-span-6 lg:col-span-3 flex flex-row gap-4 items-end'>
                        {/* 
                    <InputField
                        label={t('Birthday')}
                        type='date'
                        {...register('birth_date' ,{required:{value:true , message:errorText(t('Birthday'))}})}
                        {...errorGenertor('birth_date')}

                    /> */}

                        <Select
                            label={t('Birthday')}
                            {...register('bth_year', { required: { value: true, message: errorText(t('Year')) } })}
                            options={Array.from(new Array(80)).map((item, index) => ({ value: (moment().toDate().getFullYear() - 15 - index).toString(), label: (moment().toDate().getFullYear() - 15 - index).toString() }))}
                            {...errorGenertor('bth_year')}
                            unselectedLabel={`-- ${t('Year')} --`} />

                        <Select
                            {...register('bth_month', { required: { value: true, message: errorText(t('Month')) } })}
                            {...errorGenertor('bth_month')}
                            label={t('Month')}
                            unselectedLabel={`-- ${t('Month')} --`}
                            options={Array.from(new Array(12)).map((f, index) => ({ label: `${moment(`2025-${12 - index}-10`).format('MMMM')} (${(12 - index).toString()})`, value: (12 - index).toString() }))} />

                        <Select
                            {...register('bth_day', { required: { value: true, message: errorText(t('Day')) } })}
                            {...errorGenertor('bth_day')}
                            label={t('Day')}
                            unselectedLabel={`-- ${t('Day')} --`}
                            options={Array.from(new Array(31)).map((f, index) => ({ label: (31 - index).toString(), value: (31 - index).toString() }))}
                        />
                    </div>

                    <div className='col-span-6 lg:col-span-2'>
                        <InputField
                            label={t('PlaceOfBirth')}
                            {...register('place_of_birth', { required: { value: true, message: errorText(t('PlaceOfBirth')) } })}
                            {...errorGenertor('place_of_birth')}

                        />
                    </div>

                    <div className='col-span-6 lg:col-span-3'>

                        <Select
                            options={data?.details.data.data?.map(i => ({ label: lng == 'fa' ? i.fa_name : i.en_name, value: i.id.toString() }))}
                            label={t('nation')}
                            unselectedLabel={`-- ${t('Select')} ${t('nation')} -- `}
                            loading={isLoading}
                            {...register('nationality')}
                        />
                    </div>


                    <div className='col-span-6  lg:col-span-3'>
                        <Select
                            options={data?.details.data.data?.map(i => ({ label: lng == 'fa' ? i.fa_name : i.en_name, value: i.id.toString() }))}
                            label={t('PassportCountry')}
                            unselectedLabel={`-- ${t('Select')} ${t('Referral')} -- `}
                            loading={isLoading}
                            {...register('passport_country')}
                        />
                    </div>

                    {/* <div className='col-span-6  lg:col-span-2'>

                        <InputField
                            label={t('PassportNumber')}
                            {...register('passport_no', { required: { value: true, message: errorText(t('PassportNumber')) } })}
                            {...errorGenertor('passport_no')}

                        />
                    </div>

                    <div className='col-span-6 lg:col-span-2'>
                        <InputField
                            label={t('CDCNumber')}
                            {...register('cdc_no', { required: { value: true, message: errorText(t('CDCNumber')) } })}
                            {...errorGenertor('cdc_no')}

                        />
                    </div> */}




                </div>
            </div>
        </div>
    )
}
